import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-866de8fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "drawer-content" }
const _hoisted_2 = { class: "installed-detail-actions" }
const _hoisted_3 = { class: "selection-bar cm-ui-mb15" }
const _hoisted_4 = { class: "pagination-select-count" }
const _hoisted_5 = { class: "dialog-footer" }

import { computed, nextTick, reactive, ref, watch } from 'vue'
import { useCmTableListRefresh } from '@/hooks/use-cm-table-list-refresh'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import CmTable from '@/components/cmTable/index.vue'
import SearchFilterBar from '@/components/searchFilterBar/index.vue'
import BtnIcon from '@/views/dashboard/_components/btn-icon/btn-icon.vue'
import { ElMessage } from 'element-plus'
import type { TableOpt } from '@/components/cmTable/types'
import type { SoftwareInfo } from '../../software-view.service'
import ExportDropdown from '@/views/dashboard/_components/export-dropdown/export-dropdown.vue'
import {
  ClientInfo,
  InstalledDetailService,
  ListQueryParams,
  SoftwareUninstallParams,
} from './installed-detail.service'
import { listCol } from '@/utils/list-columns-i18n'

type DrawerSoftware = SoftwareInfo & { soft_hash_key?: string }


export default /*#__PURE__*/_defineComponent({
  __name: 'installed-detail',
  props: {
    software: { default: () => ({} as DrawerSoftware) },
    groupId: { default: -1 },
    hasPermission: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props

const hasPermission = computed(() => props.hasPermission)

const { t, locale } = useI18n()
const injector = useReflectiveInjector([InstalledDetailService])
const service = injector.get(InstalledDetailService)

const tableRef = ref<{
  getList: () => void
  tableRef?: { toggleRowSelection?: (row: unknown, selected?: boolean) => void; store?: { states?: { data?: { value?: ClientInfo[] } | ClientInfo[] } } }
  total?: number
} | null>(null)
const { refreshList } = useCmTableListRefresh(tableRef)

const form = reactive({
  group_id: props.groupId,
  key_word: '',
  /** 为 true 且非「全选分组」时，仅分页展示已选终端（本地切片） */
  useMemory: false,
})

const data = reactive({
  uninstallType: 0 as 0 | 1,
  uninstallDialogVisible: false,
})

const selectedRows = ref<ClientInfo[]>([])
/** 分组内全部终端（对该软件下发卸载，不枚举 device_id） */
const selectAllInGroup = ref(false)
const syncingSelection = ref(false)
const pageSelectCount = ref(0)
const currentPageRows = ref(0)

watch(
  () => props.groupId,
  (v) => {
    form.group_id = v ?? -1
  }
)

watch(
  () => [props.software?.soft_hash_key, props.software?.name],
  () => {
    selectAllInGroup.value = false
    selectedRows.value = []
    form.useMemory = false
    void refreshList()
  }
)

watch(
  () => [tableRef.value?.total, form.useMemory, selectedRows.value, selectAllInGroup.value],
  () => {
    nextTick(() => {
      syncTableSelection()
      updatePageSelectionMeta()
    })
  }
)

const pageOption = { pageNumName: 'page', pageSizeName: 'limit' }

const tableOpt = computed<TableOpt>(() => {
  void locale.value
  return {
    selection: true,
    selectColumnOpt: { width: 50 },
    selectable: () => !selectAllInGroup.value,
    columns: [
      {
        prop: 'computer_name',
        label: listCol(t, 'computerName'),
        type: 'COMPUTER',
        columnOpt: { minWidth: 200 },
      },
      { prop: 'user_mark', label: listCol(t, 'userMark'), columnOpt: {} },
      {
        prop: 'client_ip',
        label: listCol(t, 'ipAddress'),
        type: 'IP',
        columnOpt: {},
      },
      {
        prop: 'version',
        label: t('genuineSoftwareUsageColumns.version'),
        columnOpt: {},
      },
    ],
    rowKey: 'device_id',
    showActionBar: false,
    showSearch: false,
    showRightToolbar: false,
    path: 'list',
    totalPath: 'total',
    usePagination: false,
    scrollLoadThreshold: 10,
    scrollLoadDelay: 100,
    height: '100%',
  }
})

const tableActOpt = { columnOpt: { width: 0 }, actionButtons: () => [] }

const filterFormColumns = computed(() => {
  void locale.value
  return {}
})

const totalCount = computed(() => tableRef.value?.total ?? 0)
const selectCount = computed(() =>
  selectAllInGroup.value ? totalCount.value : selectedRows.value.length
)
const uninstallDisabled = computed(
  () => !selectAllInGroup.value && selectedRows.value.length === 0
)

function getCmTableBodyRows (): ClientInfo[] {
  const inner = tableRef.value?.tableRef as
    | { store?: { states?: { data?: { value?: ClientInfo[] } | ClientInfo[] } } }
    | undefined
  const raw = inner?.store?.states?.data
  const arr = raw && typeof raw === 'object' && 'value' in raw ? raw.value : raw
  return Array.isArray(arr) ? arr : []
}

function updatePageSelectionMeta() {
  const vr = getCmTableBodyRows()
  currentPageRows.value = vr.length
  pageSelectCount.value = vr.filter(
    (r) =>
      selectAllInGroup.value ||
      selectedRows.value.some((s) => s.device_id === r.device_id)
  ).length
}

function syncTableSelection() {
  const el = tableRef.value?.tableRef
  const tableData = getCmTableBodyRows()
  if (!el?.toggleRowSelection || !tableData.length) return
  syncingSelection.value = true
  tableData.forEach((row) => {
    const checked =
      selectAllInGroup.value ||
      selectedRows.value.some((s) => s.device_id === row.device_id)
    el.toggleRowSelection(row, checked)
  })
  nextTick(() => {
    syncingSelection.value = false
  })
}

async function getListApi(params: Record<string, unknown>) {
  const page = Number(params.page ?? 1)
  const limit = Number(params.limit ?? 20)

  if (form.useMemory && !selectAllInGroup.value && selectedRows.value.length > 0) {
    const all = selectedRows.value
    const start = (page - 1) * limit
    return { total: all.length, list: all.slice(start, start + limit) }
  }

  const res = await service.getTerminalList({
    group_id: form.group_id,
    key_word: String(params.key_word ?? form.key_word ?? ''),
    page,
    limit,
    soft_hash_key: props.software?.soft_hash_key,
    soft_name: props.software?.name ?? '',
  })
  return { total: res.total ?? 0, list: res.list ?? [] }
}

function onChangeSelected(selection: ClientInfo[]) {
  if (syncingSelection.value || selectAllInGroup.value) return
  selectedRows.value = selection.map((r) => ({ ...r }))
}

async function handleSearch(value: string) {
  form.key_word = value
  form.useMemory = false
  await refreshList()
}

async function handleQuery() {
  await refreshList()
}

function handleReset() {
  form.key_word = ''
  form.useMemory = false
  void refreshList()
}

function getListByMemory() {
  if (selectAllInGroup.value) return
  if (!selectedRows.value.length) return
  form.useMemory = !form.useMemory
  void refreshList()
}

function togglePageSelect() {
  if (selectAllInGroup.value) return
  const pageRows = getCmTableBodyRows()
  if (!pageRows.length) return
  const pageIds = new Set(pageRows.map((r) => r.device_id))
  const allPageSelected = pageRows.every((r) =>
    selectedRows.value.some((s) => s.device_id === r.device_id)
  )
  if (allPageSelected) {
    selectedRows.value = selectedRows.value.filter((s) => !pageIds.has(s.device_id))
  } else {
    const map = new Map(selectedRows.value.map((r) => [r.device_id, r]))
    pageRows.forEach((r) => map.set(r.device_id, r))
    selectedRows.value = Array.from(map.values())
  }
  nextTick(() => {
    syncTableSelection()
    updatePageSelectionMeta()
  })
}

function selectAllInGroupAction() {
  form.useMemory = false
  selectAllInGroup.value = true
  selectedRows.value = []
  void refreshList()
}

function selectCancel() {
  selectAllInGroup.value = false
  selectedRows.value = []
  form.useMemory = false
  void refreshList()
}

function download(type: 0 | 1) {
  const name = props.software?.name ?? ''
  const prefix = t('genuineSoftwareUsage.exportPrefixSoftwareDetail')
  const suffix = t('genuineSoftwareUsage.installedTerminals', { name })
  const q: ListQueryParams = {
    group_id: form.group_id,
    key_word: form.key_word,
    limit: 0,
    page: 0,
    soft_hash_key: props.software?.soft_hash_key,
    soft_name: props.software?.name ?? '',
  }
  service.download(type, q, `${prefix}${suffix}`)
}

function showUninstallDialog() {
  data.uninstallDialogVisible = true
}

function resetRadio() {
  data.uninstallType = 0
  data.uninstallDialogVisible = false
}

function uninstallSelectedClient() {
  service
    .uninstallSoftware({
      execute_type: Number(selectAllInGroup.value),
      uninstall_list: selectedRows.value.map(({device_id,soft_hash_key}) => ({ device_id, soft_hash_key })),
      uninstall_type: data.uninstallType,
    } as unknown as  SoftwareUninstallParams)
    .then(() => {
      ElMessage.success(t('genuineSoftwareUsage.uninstallSuccessTerminals', { count: selectedRows.value.length }))
      selectCancel()
      void refreshList()
    })
    .catch(() => {
      ElMessage.error(t('softwareManage.uninstallFailTerminals', { count:  selectedRows.value.length }))
    })
}

function uninstall() {
  data.uninstallDialogVisible = false
  uninstallSelectedClient()

}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_BlueTipsIcon = _resolveComponent("BlueTipsIcon")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(CmTable, {
      ref_key: "tableRef",
      ref: tableRef,
      modelValue: form,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form) = $event)),
      "table-opt": tableOpt.value,
      "table-act-opt": tableActOpt,
      api: getListApi,
      "page-option": pageOption,
      "has-permission": hasPermission.value,
      onChangeSelected: onChangeSelected
    }, {
      header: _withCtx(() => [
        _createVNode(SearchFilterBar, {
          modelValue: form,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form) = $event)),
          class: "installed-detail-filter-bar",
          "form-columns": filterFormColumns.value,
          disabled: !hasPermission.value,
          "show-search": true,
          "search-placeholder": _ctx.$t('common.phComputerIpUserCompact'),
          "popover-threshold": 0,
          onSearch: handleSearch,
          onQuery: handleQuery,
          onReset: handleReset
        }, {
          actions: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_el_button, {
                type: "primary",
                size: "small",
                disabled: uninstallDisabled.value,
                onClick: showUninstallDialog
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('genuineSoftwareUsage.uninstall')), 1)
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(ExportDropdown, {
                "has-permission": hasPermission.value,
                onExport: download
              }, null, 8, ["has-permission"])
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "form-columns", "disabled", "search-placeholder"]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_BlueTipsIcon, { class: "cm-ui-ml15 cm-ui-mr10" }),
          _createElementVNode("div", _hoisted_4, [
            _createTextVNode(_toDisplayString(_ctx.$t('genuineSoftwareUsage.selectionPrefix')) + " ", 1),
            _createElementVNode("a", {
              class: _normalizeClass([
                !form.useMemory ? 'req-primary' : 'req-default',
                (!selectCount.value || selectAllInGroup.value) ? 'memory-count--disabled' : '',
              ]),
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (selectCount.value && !selectAllInGroup.value && getListByMemory()), ["prevent"]))
            }, _toDisplayString(selectCount.value), 3),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('genuineSoftwareUsage.selectionTerminalSuffix')), 1)
          ]),
          (pageSelectCount.value < currentPageRows.value)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                class: "pagination-select-btn",
                type: "text",
                disabled: selectAllInGroup.value,
                onClick: togglePageSelect
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('genuineSoftwareUsage.selectPageAll')), 1)
                ]),
                _: 1
              }, 8, ["disabled"]))
            : (_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                class: "pagination-select-btn",
                type: "text",
                disabled: selectAllInGroup.value,
                onClick: togglePageSelect
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('genuineSoftwareUsage.selectPageInvert')), 1)
                ]),
                _: 1
              }, 8, ["disabled"])),
          _createVNode(_component_el_button, {
            class: "pagination-select-btn",
            type: "text",
            disabled: selectAllInGroup.value,
            onClick: selectAllInGroupAction
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('cmtable.selectAllInGroup')), 1)
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_el_button, {
            class: "pagination-select-btn",
            type: "text",
            disabled: !selectCount.value,
            onClick: selectCancel
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('cmtable.clearSelection')), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "table-opt", "has-permission"]),
    _createVNode(_component_el_dialog, {
      modelValue: data.uninstallDialogVisible,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((data.uninstallDialogVisible) = $event)),
      title: _ctx.$t('genuineSoftwareUsage.uninstallDialogTitle'),
      width: "30%",
      "destroy-on-close": "",
      "before-close": resetRadio
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_5, [
          _createVNode(_component_el_button, {
            size: "small",
            type: "primary",
            onClick: uninstall
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.confirm')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_radio, {
          modelValue: data.uninstallType,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((data.uninstallType) = $event)),
          label: 0
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('genuineSoftwareUsage.uninstallTypeNotify')), 1)
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_radio, {
          modelValue: data.uninstallType,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((data.uninstallType) = $event)),
          label: 1
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('genuineSoftwareUsage.uninstallTypeSilent')), 1)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ]))
}
}

})